<template>
  <section
    class="row no-gutters smart-recruiters-detail__section smart-recruiters-detail__section-four"
  >
    <div
      v-if="isMounted && embedUrl"
      class="smart-recruiters-detail__video-container"
    >
      <iframe
        :title="jobVideos.title || 'Video'"
        :src="embedUrl"
        class="smart-recruiters-detail__video"
        allowfullscreen
      />
    </div>
    <richtext-fi
      class="smart-recruiters-detail__video-info"
      is-theme-light
    >
      <!-- eslint-disable vue/no-v-html -->
      <div v-html="jobInfoText" />
      <!-- eslint-enable vue/no-v-html -->
    </richtext-fi>
  </section>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';
import { computed } from 'vue';

import { useIsMounted } from '@/composables/isMounted';
import { getYoutubeEmbedUrl } from '@/composables/video';
import type { SmartRecruitersJobAdSectionVideos } from '@/generated/graphql';

defineOptions({ name: 'SmartRecruitersDetailSectionFour' });

const props = withDefaults(
  defineProps<{
    jobVideos?: SmartRecruitersJobAdSectionVideos;
    jobInfoTitle?: string;
    jobInfoText?: string;
  }>(),
  {
    jobVideos: () => ({}),
    jobInfoTitle: '',
    jobInfoText: '',
  },
);

/**
 * The iframe waits for mount because Cookiebot runs in auto-blocking mode: without marketing
 * consent it strips `src` into `data-cookieblock-src`, rewrites the class and adds attributes of its
 * own - and it does that to server-rendered markup before Vue hydrates, so the vdom no longer
 * matches the DOM it is hydrating. Creating the iframe after mount leaves Cookiebot a node it can
 * block without anything having to agree about it first. IFrameFi does the same.
 */
const isMounted = useIsMounted();

// SmartRecruiters authors paste arbitrary links, and every level of the videos
// section is nullable, so resolve to null and skip the iframe rather than
// building a broken src.
const embedUrl = computed(() => getYoutubeEmbedUrl(props.jobVideos?.urls?.[0]));
</script>

<style scoped src="./smart-recruiters-detail-section-four" />
